import script from "./DetailTicket.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailTicket.vue?vue&type=script&setup=true&lang=ts"

import "./DetailTicket.vue?vue&type=style&index=0&id=d6e12fae&lang=css"

const __exports__ = script;

export default __exports__